import { Button, ButtonGroup, Banner, Icon, Pagination, Popover, Link, TextField, ActionList, Page, EmptyState, Modal, FooterHelp, InlineStack, Text, Card, BlockStack, Tooltip } from '@shopify/polaris';
import { DI, DIProps } from '../../../../Core';
import NoResultsFound from '../../../../Asests/Images/NoResultsFound.png'
import { SearchMinor, ArchiveMajor, CancelSmallMinor, ViewMajor, CircleInformationMajor, OrdersMajor } from '@shopify/polaris-icons';
import React, { useCallback, useState, useEffect, useRef } from 'react';
import { Table } from 'antd';
import ReactJson from "react-json-view";
import { RenderHeadersAction } from '../../Panel';
import { syncConnectorInfo } from '../../../../Actions';
import { useDebounce } from '../../useDebounce';
import { FailedOrderSkeleton } from '../skeleton/FailedSkeleton';
import { useTranslation } from 'react-i18next';

interface Props extends DIProps {
    syncNecessaryInfo: () => void;
    syncConnectorInfo: (props: any, shop_url?: string | null, updateCurrentShop?: boolean, updateStepStatus?: React.Dispatch<React.SetStateAction<string>>) => void;
    syncProfileInfo: () => void;
    loginStatus: () => void;
    syncServices: () => void;
}

function FailedOrder(props: Props) {
    const { t } = useTranslation();
    const overviewColumns = [
        {
            title: 'Amazon Order Id',
            dataIndex: 'id',
            width: '250px',
        },
        {
            title: 'App Status',
            dataIndex: 'amazonStatus',
            width: '200px',
        },
        {
            title: 'Failure Reason',
            dataIndex: 'reason',
            width: '500px',
        },
        {
            title: 'Created at',
            dataIndex: 'created_at',
            width: '12%'
        },
        {
            title: 'Actions',
            dataIndex: 'actions',
            width: '100px',
        }
    ];
    const failedColumns = [
        {
            title: 'Order Id',
            dataIndex: 'id',
            width: '22%'
        },
        {
            title: 'App Status',
            dataIndex: 'amazonStatus',
            width: '12%'
        },
        {
            title: 'Shopify Status',
            dataIndex: 'shopify_status',
        },
        {
            title: 'Shipping Status',
            dataIndex: 'shipping_status',
            width: '12%'
        },
        {
            title: 'Reason',
            dataIndex: 'reason',
            width: '32%'
        },
        {
            title: 'Created at',
            dataIndex: 'created_at',
            width: '15%'
        },
        {
            title: 'Actions',
            dataIndex: 'actions',
            width: '30%'
        }
    ];
    const [totalPages, setTotalPages] = useState<number>(0);
    const [activePage, setActivePage] = useState<number>(1);
    const [pageCount, setpageCount] = useState<number>(10);
    const [popoverActive, setPopoverActive] = useState<boolean>(true);
    const [inputValue, setInputValue] = useState('');
    const [gridRows, setGridRows] = useState<any>([]);
    const [activateModal, setActivateModal] = useState<boolean>(false);
    const [activateImportModal, setactivateImportModal] = useState<boolean>(false);
    const [importLoader, setImportLoader] = useState<boolean>(false)
    const [importOrderId, setImportOrderId] = useState<string>('');
    const [loader, setLoader] = useState<boolean>(true);
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [showSkeleton, setShowSkeleton] = useState<boolean>(false);
    const [archiveOrdersArr, setArchiveOrdersArr] = useState<string[]>([]);
    const [activateViewModal, setActivateViewModal] = useState<boolean>(false);
    const [viewModalData, setViewModalData] = useState<any>({});
    const [activateErrorModal, setActivateErrorModal] = useState<boolean>(false);
    const [bannerError, setBannerError] = useState<any>('');
    const [activateCreateModal, setActivateCreateModal] = useState<boolean>(false);
    const [createLoader, setCreateLoader] = useState<boolean>(false);
    const [createOrderId, setCreateOrderId] = useState<string>('');
    const [importError, setimportError] = useState<boolean>(false);
    const prevInput = useRef('')
    const callFetched = useRef<boolean>(false)
    const togglePopoverActive = useCallback(
        () => setPopoverActive((popoverActive) => !popoverActive),
        [],
    );
    const activator = (
        <Button onClick={togglePopoverActive} disclosure size='slim'>
            Select Actions
        </Button>
    );
    const updateText = (value: string) => {
        setInputValue(value);
    }

    const handleViewBtn = (order_id: string) => {
        props.history(`../view-order/${order_id}`)
    }
    const handleModalClose = () => {
        setArchiveOrdersArr([]);
        setActivateModal((prevState: boolean) => !prevState);
    }
    const handleModalChange = () => {
        setActivateModal(!activateModal);
        setSelectedRowKeys([]);
        archiveFailedOrders();
    };
    const handleImportModalClose = () => {
        setactivateImportModal(!activateImportModal);
        setFetchOrderData(false);
        setImportOrderId('');
        setorderData(undefined)
    }
    const handleFetchModalClose = () => {
        setorderData(undefined)
        setFetchOrderData(false);
        setImportOrderId('');
    }


    const [orderData, setorderData] = useState()
    const handleImportModalChange = async (data?: string) => {
        setImportLoader(true);


        let obj: any = {
            "source": { "marketplace": "shopify", "shopId": props?.redux?.current?.source?.['_id'] },
            "target": {
                "marketplace": "amazon", "shopId": props?.redux?.current?.target?.['_id']
            },
            "source_order_ids": importOrderId
        }

        if (importOrderId && importOrderId != "" && importOrderId.trim().length > 0) {
            if (data) {
                obj = {
                    "source": { "marketplace": "shopify", "shopId": props?.redux?.current?.source?.['_id'] },
                    "target": {
                        "marketplace": "amazon", "shopId": props?.redux?.current?.target?.['_id']
                    },
                    "order_id": importOrderId
                }
                let response = await props.di.POST('amazon/request/fetchSingleOrderData', obj);
                setImportLoader(false);
                if (response.success) {
                    props.success(t("Order fetched successfully."));
                    setorderData(response?.data)
                }
                else {
                    props.error(t(response?.message) ?? t("Oops! Some error occured."))
                    setImportOrderId('');
                }
            } else {
                let response = await props.di.POST('connector/order/importOrder', obj);
                setImportLoader(false);
                if (response.success) {
                    props.success(t("Order imported successfully."));
                    getFailedOrders();
                }
                else {
                    props.error(t(response?.message) ?? t("Oops! Some error occured."))
                    setImportOrderId('');
                }

                setactivateImportModal(!activateImportModal);
            }

        }
        else {
            props.error(t("Kindly fill Amazon order id to proceed importing of orders."))
            setImportLoader(false);
            setimportError(true);
        }
    };
    const handleArchieveBtn = (order_id: string) => {
        setArchiveOrdersArr([order_id]);
        setActivateModal((prevState: boolean) => !prevState);
    }

    const handleBulkArchive = () => {
        setActivateModal(!activateModal);
        setArchiveOrdersArr([...selectedRowKeys]);
    }
    const onSelectChange = (newSelectedRowKeys: any) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };
    useEffect(() => {
        if (selectedRowKeys.length == 0) {
            setPopoverActive(false);
        }
    }, [selectedRowKeys]);
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };
    const handleCreateBtn = (order_id: string, data: any) => {
        if (data?.marketplace_reference_id == undefined && props?.location.state?.marketplace_reference_id) {
            data.marketplace_reference_id = props?.location?.state?.marketplace_reference_id;
        }
        data['from'] = props?.match?.from;
        props.history('../transfer-order', { state: data });
        setCreateOrderId(order_id);
    }
    const handleCreateModalChange = () => {
        setActivateCreateModal(!activateCreateModal);
        createFailedOrder();
    }
    const archiveFailedOrders = async () => {
        let obj = {
            marketplace_shop_id: props?.redux?.current?.target?.['_id'],
            cif_order_id: [...archiveOrdersArr]
        }
        let response = await props.di.POST('connector/order/archiveOrder', obj);
        if (response.success) {
            props.success(t("Order(s) archived successfully."));
            getFailedOrders();
        }
        else {
            props.error(t(response?.message) ?? t("Oops! Some error occured."))
            setSelectedRowKeys([]);
        }
    }
    const createFailedOrder = async () => {
        setCreateLoader(true);
        let obj: any = {
            "source": { "marketplace": "shopify", "shopId": props?.redux?.current?.source?.['_id'] },
            "target": {
                "marketplace": "amazon", "shopId": props?.redux?.current?.target?.['_id']
            },
            "order_id": createOrderId
        }
        if (createOrderId && createOrderId != "") {
            let response = await props.di.POST('connector/order/createOrder1', obj);
            setCreateLoader(false);
            if (response.success) {
                props.success(t("Order created successfully."));
                getFailedOrders();
            }
            else {
                if (response?.data) {
                    if (response?.message && typeof response.message == 'string') {
                        props.error(response?.message)
                    }
                    response?.data?.forEach((ele: any) => {
                        if (ele?.['shop_id'] == props?.redux?.current?.source?.['_id']) {
                            props?.error(ele?.['errors']?.[0]);
                        }
                    });

                    if (response?.message) {
                        props.error(response?.message)
                    }
                } else {
                    if (response?.message && typeof response.message == 'object' && response.message?.save) {
                        Object.values(response.message.save).forEach((ele: any) => {
                            ele.failed != undefined && ele.failed[0].reason != "undefined" && props?.error(ele.failed[0]?.reason ?? "Oops! Some error occured.")
                        })
                    } else {

                        props?.error(typeof response?.message != "string" ? response.message : "Oops! Some error occured.")
                    }
                }
                setCreateOrderId('');
            }
        }
        setActivateCreateModal(!activateCreateModal);
    }
    const handleViewEyeBtn = async (cif_order_id: string) => {
        let response = await props.di.GET('connector/order/get', { cif_order_id: cif_order_id, user_id: props.di.user_id, object_type: 'source_order', marketplace_shop_id: props?.redux?.current?.target?.['_id'], marketplace: "amazon", });
        if (response.success) {
            setViewModalData({ ...response?.data });
            setActivateViewModal(!activateViewModal);
        }
        else props.error(t(response?.message) ?? t("Order data not found"))
    }
    const handleShipmentView = async (marketplace_reference_id: string, index?: any) => {
        let response = await props.di.GET('frontend/adminpanelamazonmulti/confirmShipmentHistory', { order_id: marketplace_reference_id, shop_id: props?.redux?.current?.target?.['_id'], marketplace: "amazon", user_id: props?.di?.user_id });
        if (response.success) {
            setViewModalData(response?.data);
            setActivateViewModal(!activateViewModal);
        }
        else props.error(t(response?.message) ?? t("Shipment data not found"))
    }
    const getReason = (arr: any) => {
        let reason = "N/A";
        if (arr?.length > 0) {
            let filteredTarget = arr.filter((targetData: any) => targetData?.['shop_id'] == sourceShopId);
            if (typeof (filteredTarget?.[0]?.errors?.[0]) == "string" && filteredTarget?.[0]?.errors?.[0] != "") reason = filteredTarget?.[0]?.errors?.[0];
        }
        return reason;
    }
    const getRows = (data: any) => {
        const rows = data.filter((ele: any) => ele['cif_order_id']).map((obj: any, index: number) => {
            let tempReason = getReason(obj?.['targets']);
            let row: any = {
                shipment_loader: false,
                order_loader: false,
                key: obj?.['cif_order_id'],
                id: obj?.['marketplace_reference_id'] ?? "_",
                amazonStatus: obj?.['status'] ? (obj?.['status']?.charAt(0).toUpperCase() + obj?.['status']?.slice(1)) : "_",
                reason: tempReason &&
                    <InlineStack gap="100">
                        <Text as='p' tone='critical'>{tempReason}</Text>
                    </InlineStack>,
                created_at: obj?.['created_at']?.slice(0, 10) ?? "N/A",
                actions:
                    <ButtonGroup variant="segmented">
                        {props?.match?.from == "failed" && <Tooltip content={"View Shipment's Data"}><Button loading={gridRows?.[index]?.shipment_loader ?? false} onClick={() => handleShipmentView(obj?.['marketplace_reference_id'])} icon={OrdersMajor} /></Tooltip>}
                        {props?.match?.from == "failed" && <Tooltip content={"View Order's Data"}><Button onClick={() => handleViewEyeBtn(obj?.['cif_order_id'])} icon={ViewMajor} /></Tooltip>}
                        <Button onClick={() => handleViewBtn(obj?.['cif_order_id'])}>View</Button>
                        {index === 0 ? <Button id='failedOrder_tour_3' onClick={() => {
                            handleCreateBtn(obj?.['cif_order_id'], obj)
                        }}>Create</Button> : <Button onClick={() => handleCreateBtn(obj?.['cif_order_id'], obj)}>Create</Button>}
                        <Button onClick={() => handleArchieveBtn(obj?.['cif_order_id'])}>Archive</Button>
                    </ButtonGroup>
            };
            if (props?.match?.from == "failed") {
                row['shipping_status'] = obj?.['shipping_status'] ?? "_";
                if (obj?.targets) {
                    obj.targets.forEach((e: any) => {
                        if (e?.marketplace == "shopify") {
                            row['shopify_status'] = e['status'] ? (e['status']?.charAt(0).toUpperCase() + e['status']?.slice(1)) : "_";
                            if (obj?.['status'].toLowerCase() == "failed" && e['status'].toLowerCase() != "failed") {
                                row['amazonStatus'] = "Pending";
                                row['reason'] = "_";
                            }
                            else if (obj?.['status'].toLowerCase() !== "failed" && e['status'].toLowerCase() != "failed") {
                                row['reason'] = "_";
                            }
                        }
                    });
                }
                else {
                    row['shopify_status'] = "_";
                }
            }
            return row;
        });
        return rows;
    }

    const [sourceShopId, setsourceShopId] = useState<any>(props?.redux?.current?.source?.['_id'])
    const getFailedOrders = async () => {
        setsourceShopId(props?.redux?.current?.source?.['_id']);
        setLoader(true);
        setShowSkeleton(false)
        callFetched.current = false
        let obj: any = { activePage: activePage, count: pageCount };
        props?.match?.from !== "failed" ? obj['filter[targets.status][1]'] = "failed" : ""
        if (inputValue && inputValue != "") {
            obj['filter[marketplace_reference_id][3]'] = inputValue;
        };
        if (inputValue !== prevInput.current && activePage !== 1) {
            obj.activePage = 1;
            setActivePage(1)
            return;
        }
        obj['filter[object_type][1]'] = "source_order";
        obj['filter[marketplace_shop_id][1]'] = props?.redux?.current?.target?._id;
        obj['filter[marketplace][1]'] = props?.redux?.current?.target?.marketplace;
        let response = await props.di.GET('connector/order/getAll', obj);
        setLoader(false);
        if (response.success && response?.data?.rows?.length > 0) {
            callFetched.current = true
            const rows = getRows(response?.data?.rows);

            setGridRows([...rows]);
            setTotalPages(Math.ceil(response?.data?.['count'] / pageCount));
            setShowSkeleton(false);
        }
        else {
            setShowSkeleton(true);
            setGridRows([]);
        }
        prevInput.current = inputValue
    }
    const handlePreviousPagination = () => {
        setActivePage(prev => prev - 1);
    }
    const handleNextPagination = () => {
        setActivePage(prev => prev + 1);
    }

    const [FetchOrderData, setFetchOrderData] = useState(false)
    const handleImportBtn = (data?: string) => {
        if (data) {
            setFetchOrderData(!FetchOrderData);
        } else {

            setactivateImportModal(!activateImportModal);
        }
    }

    const hasSelected = selectedRowKeys.length > 0;
    const customModal = (open: boolean, onClose: () => void, title: string, primaryAction: any, structure: any, secondaryActions: any) => {
        return <Modal
            open={open}
            onClose={onClose}
            title={t(title)}
            primaryAction={primaryAction}
            secondaryActions={secondaryActions}
        >
            {structure && structure != "" &&
                <Modal.Section>
                    {structure}
                </Modal.Section>}
        </Modal>
    }

    const debouncedValue = useDebounce(inputValue, 500)
    useEffect(() => {
        getFailedOrders();
    }, [activePage, props?.match?.from, debouncedValue]);

    return (<React.Fragment>
        <Page
            fullWidth
            backAction={props?.match?.from !== "failed" ?
                {
                    content: "Failed Orders",
                    onAction: () => {
                        props.history('../home');
                    },
                } : undefined}
            primaryAction={
                <RenderHeadersAction {...props} />
            }
            title={props?.match?.from == "failed" ? "All Orders" : "Failed Orders"
            }
            subtitle={props?.match?.from == "failed" ? "This section helps you see a list of all the Amazon orders. Here you can review All Orders and their corresponding details. Archive them or manually synchronize them after resolving the issue." : 'This section helps you see a list of the Amazon orders that have failed to sync with Shopify due to any possible reason. Here you can review the Failed Orders and their corresponding details. Archive them or manually synchronize them after resolving the issue.'}
        >
            <Card roundedAbove='sm'>

                {customModal(activateModal, handleModalClose, `${selectedRowKeys.length > 1 ? t('Archive Orders') : t('Archive Order')}`, {
                    content: t(`Confirm`),
                    onAction: handleModalChange,
                }, <Text as="p" fontWeight="regular">{`${("Do you want to archive")} ${selectedRowKeys.length > 1 ? 'these' : 'this'} ${selectedRowKeys.length > 1 ? 'orders' : 'order'}?`}</Text>, [
                    {
                        content: t('Cancel'),
                        onAction: handleModalClose,
                    },
                ])}
                {customModal(activateImportModal, handleImportModalClose, t("Import Order(s)"), {
                    content: t('Confirm'),
                    onAction: () => handleImportModalChange(),
                    loading: importLoader
                },
                    <TextField error={importError} value={importOrderId} onChange={(e) => { setImportOrderId(e); setimportError(e == "") }} autoComplete="off" placeholder={t('Enter Amazon Order Id')} label={t("Amazon order id:")}></TextField>, [
                    {
                        content: t('Cancel'),
                        onAction: handleImportModalClose,
                        disabled: importLoader
                    },
                ])}
                {customModal(FetchOrderData, handleFetchModalClose, t("View Amazon Order"), !orderData && {
                    content: t('Confirm'),
                    onAction: () => handleImportModalChange("fetch order"),
                    loading: importLoader
                },
                    orderData ? <ReactJson src={orderData} theme={"monokai"} /> : <TextField error={importError} value={importOrderId} onChange={(e) => { setImportOrderId(e); setimportError(e == "") }} autoComplete="off" placeholder={t('Enter Amazon Order Id')} label={t("Amazon order id:")}></TextField>, [
                    {
                        content: t('Cancel'),
                        onAction: handleFetchModalClose,
                        disabled: importLoader
                    },
                ])}

                {customModal(activateViewModal, () => { setActivateViewModal(!activateViewModal) }, t("Order View"), "", <ReactJson src={viewModalData} theme={"monokai"} />, [])}
                {customModal(activateErrorModal, () => { setActivateErrorModal(!activateErrorModal) }, t("Failure Reason"), "", bannerError, [])}
                {customModal(activateCreateModal, () => { setActivateCreateModal(!activateCreateModal) }, t("Create Order"), {
                    content: t('Confirm'),
                    onAction: handleCreateModalChange,
                    loading: createLoader
                }, <Text as="p" fontWeight="regular">{t("Are you sure you want to create this order?")}</Text>, [
                    {
                        content: t('Cancel'),
                        onAction: () => { setActivateCreateModal(!activateCreateModal) },
                    },
                ])}
                <BlockStack gap="200">
                    <InlineStack gap="100">
                        <div className='Custom-Stack-Item--fill'>
                            <TextField
                                autoComplete='off'
                                prefix={<div><Icon source={SearchMinor} tone="base" /></div>}
                                label=""
                                value={inputValue}
                                onChange={(e) => {
                                    e = e.toString().replace(/[!$%^&*()@+|~=`\\#{}\[\]:";'<>?,.\/_]/gi, "");
                                    e = e.toString().replace("--", "-");
                                    setInputValue(e)
                                }}
                                clearButton
                                onClearButtonClick={() => setInputValue('')}
                                placeholder="Search with Amazon Order Id"
                            />
                        </div>
                        <ButtonGroup variant="segmented">
                            <Button icon={<Icon source={ArchiveMajor} tone="base" />} onClick={() => props.history(`../archived-order/${props?.match?.from}`)}>Archived Orders</Button>
                            <Button onClick={() => handleImportBtn()}>Import Orders</Button>
                            <Button onClick={() => handleImportBtn("Fetch Order")}>View Amazon Order</Button>
                        </ButtonGroup>
                    </InlineStack>
                    {hasSelected ? <InlineStack gap="500">
                        <ButtonGroup variant="segmented">
                            <Button size='slim'>{`${selectedRowKeys.length} selected`}</Button>
                            <Button size='slim' onClick={() => setSelectedRowKeys([])} icon={CancelSmallMinor} />
                        </ButtonGroup>
                        <Popover
                            active={popoverActive}
                            activator={activator}
                            autofocusTarget="first-node"
                            onClose={togglePopoverActive}
                        >
                            <ActionList
                                actionRole="menuitem"
                                items={[
                                    { content: `${selectedRowKeys.length > 1 ? 'Archive Orders' : 'Archive Order'}`, onAction: handleBulkArchive }]}
                            />
                        </Popover>
                    </InlineStack> : null}
                    {showSkeleton ? <InlineStack gap="400" align="center">
                        <EmptyState
                            image={NoResultsFound}
                            heading={"No Orders Found"}
                        />
                    </InlineStack> :
                        (<>{!loader ? (<div id='failedOrder_tour_2'>
                            <Table
                                rowSelection={rowSelection}
                                columns={props?.match?.from !== "failed" ? overviewColumns : failedColumns}
                                dataSource={gridRows}
                                scroll={props?.match?.from == "failed" ? { x: 1000 } : { x: 1200 }}
                                pagination={false}
                                loading={loader}
                                size='middle'
                                className='custom-ant-table'
                            />
                        </div>
                        ) : (<FailedOrderSkeleton />)
                        }</>)
                    }
                    {gridRows.length > 0 &&
                        <InlineStack gap="400" align="center">
                            <Pagination
                                label={`${activePage}/${totalPages}`}
                                hasPrevious={activePage > 1 && !loader}
                                onPrevious={() => {
                                    handlePreviousPagination()
                                }}
                                hasNext={activePage < totalPages && !loader}
                                onNext={() => {
                                    handleNextPagination()
                                }}
                            />
                        </InlineStack>
                    }
                </BlockStack>
            </Card>
            <FooterHelp>
                <InlineStack align="center" gap="100">
                    <div>
                        <Icon
                            source={CircleInformationMajor}
                            tone="info"
                        />
                    </div>{t("Learn more about")}<Link target='_blank' url="https://support.cedcommerce.com/portal/en/kb/articles/overview-26-3-2024#:~:text=seller%20(your)%20credibility.-,Orders,-This%20section%20centralizes">
                        {t("CedCommerce Amazon Channel")},
                    </Link><Link target='_blank' url='https://amazon-sales-channel-app-backend.cifapps.com/Cedcommerce_Privacy_Statement.pdf'>
                        {t("Terms & Conditions")}
                    </Link>and<Link target='_blank' url='https://amazon-sales-channel-app-backend.cifapps.com/Data_Privacy_Rights.pdf'>
                        {t("Data Privacy Rights.")}
                    </Link> {t("Need Help?")}<Link target='_blank'
                        url={`https://admin.shopify.com/apps${process.env.REACT_APP_SHOPIFY_APP_BASE}/panel/user/support`}>
                        {t("Get Support")}
                    </Link>or<Link target='_blank' url="https://calendly.com/cedcommerce-awe-sales/sales" >
                        {t("Book a Call")}
                    </Link>
                </InlineStack>
            </FooterHelp>
        </Page >
    </React.Fragment>
    );
}

export default DI(FailedOrder, {
    func: {
        syncConnectorInfo,
    },
});